import { render, staticRenderFns } from "./DeActiveFAQMaster.vue?vue&type=template&id=6c8ef116&scoped=true&"
import script from "./DeActiveFAQMaster.vue?vue&type=script&lang=js&"
export * from "./DeActiveFAQMaster.vue?vue&type=script&lang=js&"
import style0 from "./DeActiveFAQMaster.vue?vue&type=style&index=0&id=6c8ef116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ef116",
  null
  
)

export default component.exports